export const DATE_FORMATS = {
    SHORT: 'MMM DD',
    LONG: 'MMM DD, YYYY',
    TIME: 'HH:mm:ss',
    FULL_DATETIME: 'MMM DD YYYY, HH:mm:ss',
};

export default DATE_FORMATS;